import Simplified from "./Simplified";
export default Simplified;